module.exports = __webpack_public_path__ + "static/9-4b22667e3f021c97c302bb36e58eeec1.jpg";